import { Main } from '../../components'
import useBasePath from '../../hooks/useBasePath'
import GuildSearch from './components/GuildSearch'
import GuildOnboarding from './components/GuildOnboarding'

const Onboarding = () => {
  const baseGuildPath = useBasePath('guild')

  return (
    <Main title='Get started' robots='noindex, nofollow'>
      {baseGuildPath ? (
        <GuildOnboarding basePath={baseGuildPath} />
      ) : (
        <GuildSearch />
      )}
    </Main>
  )
}

export default Onboarding
